module.exports = __webpack_public_path__ + "media/images/icon-testee-18796f52381fe14378d6ba08339c7469.svg";